import { connect } from 'react-redux'
import View from './LiveLink'

const mapStateToProps = state => ({
  locale: state.router.locale,
})

const LiveLink = connect(mapStateToProps)(View)

export default LiveLink
